(function () {
  // Function to get URL parameter from full URL
  function getUrlParameter(url, name) {
    // If no URL provided, use current page URL
    if (!url) {
      url = window.location.href;
    }

    // Create URL object to parse
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get(name);
    } catch (e) {
      // Fallback to regex method if URL parsing fails
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(url.split('?')[1] || '');
      return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  }

  function ensureResultPageParams() {
    const currentUrl = window.location.href;
    const resultParam = getUrlParameter(currentUrl, 'result');

    if (!resultParam) return;

    try {
      const urlObj = new URL(currentUrl);
      if (urlObj.searchParams.get('no-kit') === 'true') return;

      urlObj.searchParams.set('no-kit', 'true');
      window.history.replaceState({}, '', urlObj.toString());
    } catch (e) {
      console.warn('Unable to normalize result page URL params:', e);
    }
  }

  // Function to escape HTML
  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Helper function to create image HTML with priority: thumbnail -> image_url -> empty div
  function createAnswerImageHTML(thumbnail, imageUrl, altText) {
    if (thumbnail) {
      const escapedAlt = escapeHtml(altText || 'Answer');
      return `<img src="${escapeHtml(thumbnail)}" alt="${escapedAlt}" class="quiz-result-answer-image">`;
    } else if (imageUrl) {
      const escapedAlt = escapeHtml(altText || 'Answer');
      return `<img src="${escapeHtml(imageUrl)}" alt="${escapedAlt}" class="quiz-result-answer-image">`;
    } else {
      return `<div class="quiz-result-answer-image empty-image"></div>`;
    }
  }

  // Function to render quiz result UI
  function renderQuizResultUI(container, data) {
    
    // Extract all values into separate variables
    const userName = data.userName || null;
    const endAnswerValue = (data.endAnswer && data.endAnswer.value) ? data.endAnswer.value : null;
    const endAnswerThumbnail = (data.endAnswer && (data.endAnswer.thumbnail || data.endAnswer.thumb || data.endAnswer.thumbnail_url)) ? (data.endAnswer.thumbnail || data.endAnswer.thumb || data.endAnswer.thumbnail_url) : null;
    const endAnswerImageUrl = (data.endAnswer && (data.endAnswer.image_url || data.endAnswer.imageUrl || data.endAnswer.image)) ? (data.endAnswer.image_url || data.endAnswer.imageUrl || data.endAnswer.image) : null;
    const rootAnswerValue = (data.rootAnswer && data.rootAnswer.value) ? data.rootAnswer.value : null;
    const rootAnswerThumbnail = (data.rootAnswer && (data.rootAnswer.thumbnail || data.rootAnswer.thumb || data.rootAnswer.thumbnail_url)) ? (data.rootAnswer.thumbnail || data.rootAnswer.thumb || data.rootAnswer.thumbnail_url) : null;
    const rootAnswerImageUrl = (data.rootAnswer && (data.rootAnswer.image_url || data.rootAnswer.imageUrl || data.rootAnswer.image)) ? (data.rootAnswer.image_url || data.rootAnswer.imageUrl || data.rootAnswer.image) : null;

    // Build HTML string
    let html = '<div class="quiz-result-content"><div class="left-side-content-wrapper">';

    // Create congratulations message (only if userName exists)
    if (userName) {
      const escapedUserName = escapeHtml(userName);
      html += `
        <div class="result-with-button">
        <h2 class="heading">Results</h2>
        <span class="divider"></span>
      `;
    }

    // Create answers section (only if there are answers)
    const hasAnswers = endAnswerValue || rootAnswerValue;
    if (hasAnswers) {
      html += '<div class="quiz-result-answers">';

      // Add root answer (only if value exists)
      if (rootAnswerValue) {
        const escapedRootAnswerValue = escapeHtml(rootAnswerValue).replace(' - ', ' ');

        const rootAnswerImageHTML = createAnswerImageHTML(rootAnswerThumbnail, rootAnswerImageUrl, rootAnswerValue);
        html += `
          <div class="quiz-result-answer quiz-result-root-answer">
            <div class="quiz-result-answer-content">
              ${rootAnswerImageHTML}
              <span class="quiz-result-answer-value">${escapedRootAnswerValue}</span>
              <span class="static-text">ROOTS</span>
            </div>
          </div>
        `;
      }

      // Add end answer (only if value exists)
      if (endAnswerValue) {
        const escapedEndAnswerValue = escapeHtml(endAnswerValue).replace(' - ', ' ');
        const endAnswerImageHTML = createAnswerImageHTML(endAnswerThumbnail, endAnswerImageUrl, endAnswerValue);
        html += `
          <div class="quiz-result-answer quiz-result-end-answer">
            <div class="quiz-result-answer-content">
              ${endAnswerImageHTML}
              <span class="quiz-result-answer-value">${escapedEndAnswerValue}</span>
              <span class="static-text">ENDS</span>
            </div>
          </div>
          
        `;
      }



      html += '</div> <span class="divider"></span>';
    }

    // Create Shop Now button
    html += `
      <a class="quiz-result-shop-now btn btn--primary hidden" href="#custom-product-details">Shop Now</a>
    `;

    html += '</div></div><div class="right-image-wrapper"><div class="quiz-result-congrats"><h2 class="quiz-result-title h1">Congratulations!</h2><p class="text">We have found the perfect colour for you:</p></div></div></div>';

    // Set HTML content using innerHTML (same pattern as quiz-api-section.js)
    container.innerHTML = html;
  }

  // Function to fetch and append quiz result data
  function fetchQuizResult() {
    // Get the full current URL
    const fullUrl = window.location.href;

    // Extract the result parameter from the full URL
    const resultParam = getUrlParameter(fullUrl, 'result');

    if (!resultParam) {
      return;
    }


    // Build the API URL with the extracted parameter
    const apiUrl = `https://quiz.miiroko.com/api/v1/quiz/result?result=${encodeURIComponent(resultParam)}`;
    const resultsContainer = document.querySelector('.main-api-get-results');

    if (!resultsContainer) {
      console.warn('Quiz results container (.main-api-get-results) not found, retrying...');
      // Retry after a short delay
      setTimeout(fetchQuizResult, 100);
      return;
    }

    // Make the API call
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // Check if data already exists to avoid duplicates
        const existingData = resultsContainer.querySelector('.quiz-result-data');
        if (existingData) {
          existingData.remove();
        }

        // Helper function to search for a property in nested objects
        function findProperty(obj, propertyNames) {
          if (!obj || typeof obj !== 'object') return null;

          // Check direct properties first
          for (const prop of propertyNames) {
            if (obj.hasOwnProperty(prop) && obj[prop] != null) {
              return obj[prop];
            }
          }

          // Search in nested objects
          for (const key in obj) {
            if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && obj[key] !== null) {
              const found = findProperty(obj[key], propertyNames);
              if (found != null) return found;
            }
          }

          return null;
        }

        // Extract result_id and session_token from the API response (checking multiple possible property names and nested locations)
        const resultId = findProperty(data, ['result_id', 'resultId', 'result-id', 'resultId', 'id']);
        const sessionToken = findProperty(data, ['session_token', 'sessionToken', 'session-token', 'token']);

        // Store result_id and session_token as data attributes on the container
        if (resultId) {
          resultsContainer.setAttribute('data-result-id', resultId);
          const resultIdInput = document.querySelector('.custom-result-id input');
          if (resultIdInput) {
            resultIdInput.setAttribute('value', resultId);
          }
        }
        if (sessionToken) {
          resultsContainer.setAttribute('data-session-token', sessionToken);
          const sessionTokenInput = document.querySelector('.custom-session-token input');
          if (sessionTokenInput) {
            sessionTokenInput.setAttribute('value', sessionToken);
          }
        }

        // Extract additional fields for UI display
        const userName = findProperty(data, ['user_name', 'userName', 'user-name', 'name']);
        const recommendations = findProperty(data, ['recommendations', 'recommendation', 'recommendations_list']);

        // Extract end_answer and root_answer identifiers
        const endAnswerId = findProperty(data, ['end_answer', 'endAnswer', 'end-answer']);
        const rootAnswerId = findProperty(data, ['root_answer', 'rootAnswer', 'root-answer']);

        // Find the matching recommendations
        let endAnswerData = null;
        let rootAnswerData = null;

        // Check if end_answer/root_answer are already objects with value and image_url
        if (endAnswerId && typeof endAnswerId === 'object' && endAnswerId.value !== undefined) {
          endAnswerData = endAnswerId;
        }

        if (rootAnswerId && typeof rootAnswerId === 'object' && rootAnswerId.value !== undefined) {
          rootAnswerData = rootAnswerId;
        }

        // If not objects, search in recommendations array
        if (Array.isArray(recommendations)) {
          if (!endAnswerData) {
            // Try to find by matching the identifier with recommendation value or id
            endAnswerData = recommendations.find(rec => {
              if (!rec || typeof rec !== 'object') return false;
              return rec.value === endAnswerId ||
                rec.id === endAnswerId ||
                rec.answer === endAnswerId ||
                rec.answer_id === endAnswerId ||
                String(rec.value).includes(String(endAnswerId)) ||
                String(endAnswerId).includes(String(rec.value));
            });

            // If not found by matching, try to find by index or position
            // Sometimes end_answer and root_answer might be indices
            if (!endAnswerData && endAnswerId !== null && endAnswerId !== undefined) {
              const endAnswerStr = String(endAnswerId);
              if (endAnswerStr.match(/^\d+$/)) {
                const index = parseInt(endAnswerStr, 10);
                if (recommendations[index]) {
                  endAnswerData = recommendations[index];
                }
              }
            }
          }

          if (!rootAnswerData) {
            // Try to find by matching the identifier with recommendation value or id
            rootAnswerData = recommendations.find(rec => {
              if (!rec || typeof rec !== 'object') return false;
              return rec.value === rootAnswerId ||
                rec.id === rootAnswerId ||
                rec.answer === rootAnswerId ||
                rec.answer_id === rootAnswerId ||
                String(rec.value).includes(String(rootAnswerId)) ||
                String(rootAnswerId).includes(String(rec.value));
            });

            // If not found by matching, try to find by index or position
            if (!rootAnswerData && rootAnswerId !== null && rootAnswerId !== undefined) {
              const rootAnswerStr = String(rootAnswerId);
              if (rootAnswerStr.match(/^\d+$/)) {
                const index = parseInt(rootAnswerStr, 10);
                if (recommendations[index]) {
                  rootAnswerData = recommendations[index];
                }
              }
            }
          }
        }

        // Create the quiz-result-data div first
        const dataElement = document.createElement('div');
        dataElement.className = 'quiz-result-data';
        dataElement.setAttribute('data-quiz-result', JSON.stringify(data));
        // Don't hide it - we want to show the content inside it
        resultsContainer.appendChild(dataElement);

        // Render the quiz result UI inside the quiz-result-data div
        renderQuizResultUI(dataElement, {
          userName: userName,
          endAnswer: endAnswerData,
          rootAnswer: rootAnswerData
        });

        // Dispatch a custom event to notify other scripts
        const event = new CustomEvent('quizResultLoaded', { detail: data });
        document.dispatchEvent(event);

        // Extract pdp data and populate product detail divs
        const pdp = findProperty(data, ['pdp', 'PDP']);

        // Helper function to create unordered list HTML from array or string
        function createListHTML(value) {
          if (!value) return '';

          let items = [];
          if (Array.isArray(value)) {
            items = value;
          } else if (typeof value === 'string') {
            // If it's a string, try to split by newlines or commas
            items = value.split(/\n|,|\r\n/).map(item => item.trim()).filter(item => item);
          } else {
            return '';
          }

          if (items.length === 0) return '';

          let listHTML = '<ul class="color-application-list">';
          items.forEach(item => {
            const escapedItem = escapeHtml(item);
            listHTML += `<li class="color-application-item">${escapedItem}</li>`;
          });
          listHTML += '<li class="color-application-item">Reusable</li><li class="color-application-item">Ammonia and PPD free</li></ul>';

          return listHTML;
        }

        // Helper function to create unordered list HTML from array or string (generic version without static items)
        function createGenericListHTML(value, listClass, itemClass) {
          if (!value) return '';

          let items = [];
          if (Array.isArray(value)) {
            items = value;
          } else if (typeof value === 'string') {
            // If it's a string, try to split by newlines or commas
            items = value.split(/\n|,|\r\n/).map(item => item.trim()).filter(item => item);
          } else {
            return '';
          }

          if (items.length === 0) return '';

          const listClassName = listClass || 'product-benefits-list';
          const itemClassName = itemClass || 'product-benefits-item';

          let listHTML = `<ul class="${listClassName}">`;
          items.forEach(item => {
            const escapedItem = escapeHtml(item);
            listHTML += `<li class="${itemClassName}">${escapedItem}</li>`;
          });
          listHTML += '</ul>';

          return listHTML;
        }

        // Helper function to create plain text from array or string
        function createPlainText(value) {
          if (!value) return '';

          let text = '';
          if (Array.isArray(value)) {
            text = value.join(' ');
          } else if (typeof value === 'string') {
            text = value;
          } else {
            return '';
          }

          return escapeHtml(text);
        }

        // Extract and populate colour_application (with UL-LI structure)
        if (pdp && typeof pdp === 'object') {
          const colourApplication = pdp.colour_application || pdp.color_application || pdp.colourApplication || pdp.colorApplication;
          const colourApplicationHTML = createListHTML(colourApplication);
          const colourApplicationDiv = document.querySelector('#color-application-text');
          if (colourApplicationDiv && colourApplicationHTML) {
            colourApplicationDiv.innerHTML = colourApplicationHTML;
          }

          // Extract and populate keratin_booster (with bold formatting for **text**)
          const keratinBooster = pdp.keratin_booster || pdp.keratinBooster;
          let keratinBoosterText = '';
          if (keratinBooster) {
            if (Array.isArray(keratinBooster)) {
              keratinBoosterText = keratinBooster.join(' ');
            } else if (typeof keratinBooster === 'string') {
              keratinBoosterText = keratinBooster;
            }

            // Escape HTML first
            const escapedText = escapeHtml(keratinBoosterText);

            // Replace **text** with <span class="bold">text</span>
            keratinBoosterText = escapedText.replace(
              /\*\*(.+?)\*\*/g,
              '<span class="bold">$1</span>'
            );
          }

          const keratinBoosterDiv = document.querySelector('#keratin-booster-text');
          if (keratinBoosterDiv && keratinBoosterText) {
            keratinBoosterDiv.innerHTML = keratinBoosterText;
          }

          // Extract and populate Special_Text (plain text only)
          const mainProductTitleText = `YOUR HAIR COLOUR COMBO`;
          const mainProductTitleDiv = document.querySelector('h1.product-title');
          const mainInstractionTitle = document.querySelector('.personalised-instructions .instructions-left');
          if (mainProductTitleDiv) {
            mainProductTitleDiv.innerHTML = mainProductTitleText;
          }
          // if (mainInstractionTitle) {
          //   const titleElement = mainInstractionTitle.querySelector('.title');
          //   if (titleElement) {
          //     titleElement.innerHTML = `Your instructions`;
          //   }
          // }

          // Extract and populate Special_Text (plain text only)
          const staticSpecialText = `Specially selected colour care bundle for <span class="user-name">${userName}.</span>`;
          const staticSpecialDiv = document.querySelector('#special-text');
          if (staticSpecialDiv) {
            staticSpecialDiv.innerHTML = staticSpecialText;
          }

          // Extract and populate include (with bold formatting for **text**)
          const include = pdp.include;
          let includeText = '';
          if (include) {
            if (Array.isArray(include)) {
              includeText = include.join(' ');
            } else if (typeof include === 'string') {
              includeText = include;
            }

            // Escape HTML first
            const escapedText = escapeHtml(includeText);

            // Replace **text** with <span class="bold">text</span>
            includeText = escapedText.replace(
              /\*\*(.+?)\*\*/g,
              '<span class="bold">$1</span>'
            );
          }

          const includeDiv = document.querySelector('#include-text');
          if (includeDiv && includeText) {
            includeDiv.innerHTML = includeText;
          }

          // Extract and populate benefits (with UL-LI structure)
          const benefits = pdp.benefits;
          const benefitsHTML = createGenericListHTML(benefits, 'product-benefits-list', 'product-benefits-item');
          const benefitsDiv = document.querySelector('#product-benefits-text');
          if (benefitsDiv && benefitsHTML) {
            benefitsDiv.innerHTML = benefitsHTML;
          }
        }

        // Extract and populate instructions steps
        // Try multiple ways to find instructions
        const instructions = findProperty(data, ['instructions', 'Instructions', 'instruction', 'Instruction']);

        // Also check if steps is directly in data
        let steps = findProperty(data, ['steps', 'Steps']);

        // Extract how_to_video_embed from instructions or directly from data
        let howToVideoEmbed = null;
        if (instructions && typeof instructions === 'object') {
          howToVideoEmbed = instructions.how_to_video_embed || instructions.howToVideoEmbed || instructions.video_embed || instructions.videoEmbed;
        }
        // Also check directly in data
        if (!howToVideoEmbed) {
          howToVideoEmbed = findProperty(data, ['how_to_video_embed', 'howToVideoEmbed', 'video_embed', 'videoEmbed']);
        }

        // Extract how_to_page_title (supports nested objects like { generated_instructions: ... })
        let howToPageTitle = null;
        let howToPageUrl = '#';
        if (instructions && typeof instructions === 'object') {
          howToPageTitle = instructions.how_to_page_title || instructions.howToPageTitle || instructions.how_to_video_title || instructions.howToVideoTitle;
          
          if(instructions.generated_instructions.how_to_page_url) {
            howToPageUrl = instructions.generated_instructions.how_to_page_url;  
          }
        }

        if(howToPageUrl) {
          const seeDetailBtn = document.querySelector('.see-detail-btn');
          if(seeDetailBtn) {
            seeDetailBtn.setAttribute('href', howToPageUrl);
          }
        }

        if (!howToPageTitle) {
          howToPageTitle = findProperty(data, ['how_to_page_title', 'howToPageTitle', 'how_to_video_title', 'howToVideoTitle']);
        }

        const setInstructionVideoTitle = (titleValue, retry = 0) => {
          const el = document.querySelector('.instructions-main .video-top-main .custom-instruction-video-title');
          if (!el) {
            if (retry < 10) setTimeout(() => setInstructionVideoTitle(titleValue, retry + 1), 300);
            return;
          }
          let titleText = '';
          if (typeof titleValue === 'string') {
            titleText = titleValue;
          } else if (titleValue && typeof titleValue === 'object') {
            titleText = titleValue.generated_instructions ||
              titleValue.generatedInstructions ||
              titleValue.value ||
              titleValue.text ||
              titleValue.title ||
              '';
          }
          if (Array.isArray(titleText)) titleText = titleText.find(Boolean) || '';
          if (titleText && typeof titleText === 'object') {
            titleText = titleText.value || titleText.text || titleText.title || '';
          }
          el.textContent = String(titleText || '').trim();
        };

        if (howToPageTitle) {
          setInstructionVideoTitle(howToPageTitle);
        }

        // Function to inject YouTube video into the video-wrapper
        const injectHowToVideo = (embedValue, retry = 0) => {
          // Targets: main instructions video + personalised instructions video
          const selectors = [
            '.instructions-main .video-top-main .video-wrapper',
            '.personalised-instructions .video-top-main .video-wrapper'
          ];

          const wrappers = selectors
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

          if (wrappers.length === 0) {
            if (retry < 10) {
              setTimeout(() => injectHowToVideo(embedValue, retry + 1), 300);
              return;
            } else {
              console.warn('Video wrappers not found after retries for how_to_video_embed');
              return;
            }
          }


          // If the payload already contains an iframe, extract and inject it
          let iframeNode = null;
          if (typeof embedValue === 'string' && embedValue.toLowerCase().includes('<iframe')) {
            const temp = document.createElement('div');
            temp.innerHTML = embedValue;
            iframeNode = temp.querySelector('iframe');
          }

          // Convert YouTube URL to embed format
          const toYouTubeEmbed = (url) => {
            let embed = String(url || '').trim();
            if (!embed) return null;

            // If already an embed URL, return as is
            if (embed.includes('youtube.com/embed/')) {
              if (!embed.startsWith('http')) {
                embed = 'https://' + embed.replace(/^\/\//, '');
              }
              return embed;
            }

            // Convert common YouTube URL formats to embed format
            if (embed.includes('youtube.com/watch')) {
              const videoId = embed.match(/[?&]v=([^&]+)/);
              if (videoId && videoId[1]) {
                embed = 'https://www.youtube.com/embed/' + videoId[1];
              } else {
                embed = embed.replace(/youtube\.com\/watch\?v=/, 'youtube.com/embed/').split('&')[0];
              }
            } else if (embed.includes('youtu.be/')) {
              const videoId = embed.match(/youtu\.be\/([^?]+)/);
              if (videoId && videoId[1]) {
                embed = 'https://www.youtube.com/embed/' + videoId[1];
              } else {
                embed = embed.replace(/https?:\/\/youtu\.be\//, 'https://www.youtube.com/embed/').split('?')[0];
              }
            }

            // Ensure https
            if (embed.startsWith('//')) embed = 'https:' + embed;
            if (!embed.startsWith('http')) embed = 'https://' + embed;

            return embed;
          };

          // Build iframe if not supplied
          const ensureIframe = () => {
            if (iframeNode) return iframeNode.cloneNode(true);
            const embedUrl = toYouTubeEmbed(embedValue);
            if (!embedUrl) return null;
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('allowfullscreen', 'true');
            return iframe;
          };

          wrappers.forEach(wrapper => {
            const iframe = ensureIframe();
            if (iframe) {
              wrapper.innerHTML = '';
              wrapper.appendChild(iframe);
            } else {
              console.warn('how_to_video_embed found but could not convert to embed URL or iframe:', embedValue);
            }
          });
        };

        // Process how_to_video_embed if found
        if (howToVideoEmbed) {

          let rawVideoUrl = null;

          // If it's a string, use it directly
          if (typeof howToVideoEmbed === 'string') {
            rawVideoUrl = howToVideoEmbed;
          }
          // If it's an object, look for nested properties
          else if (typeof howToVideoEmbed === 'object') {
            rawVideoUrl = howToVideoEmbed.generated_instructions ||
              howToVideoEmbed.generatedInstructions ||
              howToVideoEmbed.url ||
              howToVideoEmbed.link ||
              howToVideoEmbed.src ||
              howToVideoEmbed.value;
          }

          // Unwrap arrays/objects to get a usable string
          if (Array.isArray(rawVideoUrl)) {
            rawVideoUrl = rawVideoUrl.find(item => item);
          }
          if (rawVideoUrl && typeof rawVideoUrl === 'object') {
            rawVideoUrl = rawVideoUrl.url || rawVideoUrl.link || rawVideoUrl.src || rawVideoUrl.value;
          }

          if (rawVideoUrl) {
            injectHowToVideo(rawVideoUrl);
          } else {
            console.warn('how_to_video_embed found but no valid URL extracted:', howToVideoEmbed);
          }
        }

        // If instructions found, get steps from it
        if (instructions && typeof instructions === 'object') {
          steps = instructions.steps || instructions.Steps || instructions.step || instructions.Step || steps;
        }

        // If steps is not an array, try to convert it
        if (steps && !Array.isArray(steps)) {
          if (typeof steps === 'object' && steps !== null) {
            // If it's an object, try to get an array from it
            steps = Object.values(steps).filter(item => item && typeof item === 'object');
          } else {
            steps = [];
          }
        }
        if (Array.isArray(steps) && steps.length > 0) {
          // Function to find and populate the container (with retry)
          function findAndPopulateContainer(retryCount = 0) {
            const instructionStepsContainer = document.querySelector('.multiple-instruction-steps');

            if (!instructionStepsContainer && retryCount < 10) {
              // Retry after a short delay (element might not be in DOM yet or tab might be hidden)
              // Increased retries to 10 and delay to 300ms to handle hidden tabs
              setTimeout(() => findAndPopulateContainer(retryCount + 1), 300);
              return;
            }

            if (instructionStepsContainer) {
              // Clear existing static steps
              instructionStepsContainer.innerHTML = '';

              // Map of step numbers to image URLs
              const stepNumberImages = {
                1: 'https://cdn.shopify.com/s/files/1/0725/6267/1867/files/number1.png?v=1762343949',
                2: 'https://cdn.shopify.com/s/files/1/0725/6267/1867/files/number-2.png?v=1762343953',
                3: 'https://cdn.shopify.com/s/files/1/0725/6267/1867/files/number-3.png?v=1762346956',
                4: 'https://cdn.shopify.com/s/files/1/0725/6267/1867/files/number-4.png?v=1762346956',
                5: 'https://cdn.shopify.com/s/files/1/0725/6267/1867/files/number-5.png?v=1762346956'
              };

              let stepsHTML = '';

              steps.forEach((step, index) => {
                if (!step || typeof step !== 'object') return;

                const stepNumber = index + 1;
                const stepTitle = step.step_title || step.stepTitle || step.title || step.Title || '';
                const stepIcon = step.icon || '';

                // Try multiple field names to find instructions (since instruction field was removed from API)
                // Check for arrays first, then strings
                let instruction = step.instructions || step.Instructions ||
                  step.instruction_text || step.instructionText ||
                  step.text || step.Text ||
                  step.content || step.Content ||
                  step.description || step.Description ||
                  step.desc || step.desc_text ||
                  step.body || step.Body || '';

                // If still empty or not an array/string/object, search through all step properties for instruction-like data
                // Note: Empty arrays [] are truthy, so ![] is false, which is correct - we want to process arrays
                if (!instruction ||
                  (instruction === '') ||
                  (typeof instruction !== 'string' && !Array.isArray(instruction) && (typeof instruction !== 'object' || instruction === null))) {
                  for (const key in step) {
                    if (step.hasOwnProperty(key)) {
                      const lowerKey = key.toLowerCase();
                      // Check if key name suggests it might contain instructions
                      if (lowerKey.includes('instruction') ||
                        lowerKey.includes('text') ||
                        lowerKey.includes('content') ||
                        lowerKey.includes('description') ||
                        lowerKey.includes('body') ||
                        lowerKey.includes('desc')) {
                        const value = step[key];
                        if (value && (typeof value === 'string' || Array.isArray(value) || typeof value === 'object')) {
                          instruction = value;
                          break;
                        }
                      }
                    }
                  }
                }

                // Skip only if both title and instruction are empty
                if (!stepTitle && !instruction) {
                  return;
                }

                // Get the number image URL (fallback to first if step number exceeds available images)
                const numberImageUrl = stepNumberImages[stepNumber] || stepNumberImages[1];

                // Escape HTML for safety
                const escapedStepTitle = escapeHtml(stepTitle || '');
                const sanitizedTitle = escapedStepTitle.split(' ').join('-');
                let formattedInstructionHTML = '';

                // Check if instruction exists and has content
                // Handle arrays, strings, objects, and other types
                if (instruction !== null && instruction !== undefined && instruction !== '') {
                  let instructionValues = [];

                  // Check if instruction is an array
                  if (Array.isArray(instruction)) {
                    // Filter out empty/null/undefined values and ensure we have valid strings
                    instructionValues = instruction
                      .filter(item => item !== null && item !== undefined && item !== '')
                      .map(item => String(item).trim())
                      .filter(item => item !== '');
                    
                  } else if (typeof instruction === 'string') {
                    // If it's a string, split by newlines to get multiple values
                    instructionValues = instruction.split(/\n|\r\n/).map(item => item.trim()).filter(item => item);
                  } else if (typeof instruction === 'object' && instruction !== null) {
                    // If it's an object, try to extract text/value from it
                    const objText = instruction.text || instruction.Text ||
                      instruction.value || instruction.Value ||
                      instruction.content || instruction.Content ||
                      instruction.description || instruction.Description ||
                      instruction.body || instruction.Body ||
                      '';
                    if (objText) {
                      if (Array.isArray(objText)) {
                        instructionValues = objText.filter(item => item !== null && item !== undefined && item !== '');
                      } else {
                        instructionValues = [String(objText)].filter(item => item !== '');
                      }
                    } else {
                      // If object has no text property, try to stringify it
                      const stringified = JSON.stringify(instruction);
                      if (stringified && stringified !== '{}') {
                        instructionValues = [stringified];
                      }
                    }
                  } else {
                    // Convert to string if it's another type
                    const strValue = String(instruction);
                    if (strValue && strValue !== 'undefined' && strValue !== 'null') {
                      instructionValues = [strValue];
                    }
                  }

                  // Only process if we have valid instruction values
                  if (instructionValues.length === 0) {
                    console.warn(`Step ${stepNumber}: No valid instruction values found after processing`, { instruction, instructionType: typeof instruction });
                  }

                  // Process each instruction value and create a separate instraction-text element for each
                  instructionValues.forEach(value => {
                    if (!value || value === '') return;

                    // Escape HTML first
                    let formattedValue = value;

                    // Replace **text** with <strong>text</strong> in instruction (handle multiple occurrences)
                    formattedValue = formattedValue.replace(
                      /\*\*(.+?)\*\*/g,
                      '<strong>$1</strong>'
                    );

                    // Replace multiple spaces with single space (but preserve intentional spacing)
                    formattedValue = formattedValue.replace(/  +/g, ' ');

                    formattedValue = formattedValue.replace(' - ', ' ');

                    // Create a separate instraction-text element for each value
                    formattedInstructionHTML += `<p class="instraction-text">${formattedValue}</p>`;
                  });

                  if (!formattedInstructionHTML) {
                    console.warn(`Step ${stepNumber}: Instruction found but no valid values extracted`, instruction);
                  }
                } else {
                  console.warn(`Step ${stepNumber}: No instruction found`, { stepTitle, stepKeys: Object.keys(step) });
                }

                // Create step HTML - always show step if title exists, even if instruction is empty
                const stepHTML = `
                  <div class="step">
                    <div class="step-conent-left">
                      <div class="step-conent-left-content">
                        <img src="${numberImageUrl}" alt="Step ${stepNumber}">
                        <h2 class="step-count-head step-text-${sanitizedTitle.toLocaleLowerCase()} h1">${escapedStepTitle}</h2>
                      </div>  
                    </div>
                    <div class="step-content-right">
                      <img src="${stepIcon}">
                      ${formattedInstructionHTML || '<p class="instraction-text"></p>'}
                    </div>
                  </div>
                `;

                stepsHTML += stepHTML;
              });

              if (stepsHTML) {
                instructionStepsContainer.innerHTML = stepsHTML;
              } else {
                console.warn('No valid steps found to populate');
              }
            } else {
              console.warn('Instruction steps container (.multiple-instruction-steps) not found after retries');
            }
          }

          // Start trying to populate
          findAndPopulateContainer();
        }

      })
      .catch(error => {
        console.error('Error fetching quiz result:', error);
        const escapedErrorMessage = escapeHtml('Error loading quiz results: ' + error.message);
        const errorHTML = `<div class="quiz-result-error">${escapedErrorMessage}</div>`;
        resultsContainer.innerHTML = errorHTML;
      });
  }

  // Custom Klaviyo form section: show when URL has ?result= and form not yet submitted; hide after submit or when no result param
  const QUIZ_FORM_SUBMITTED_PREFIX = 'quiz_form_submitted_';
  const SHOP_DOMAIN = 'miiroko-au.myshopify.com';

  function initKlaviyoFormSection() {
    const section = document.querySelector('.custom-klaviyo-form-section');
    if (!section) return;
    const triggerWrapper = document.querySelector('.custom-klaviyo-form-button');
    const triggerButton = document.querySelector('.custom-klaviyo-form-button .button');
    const triggerSvgWrapper = triggerWrapper ? triggerWrapper.querySelector('.svg-wrapper') : null;

    const setSuccessState = (isSuccess) => {
      section.classList.toggle('show-success-state', Boolean(isSuccess));
    };

    const resultParam = getUrlParameter(window.location.href, 'result');
    let isSubmitted = false;

    if (!resultParam) {
      section.classList.add('hidden');
      setSuccessState(false);
    } else {
      const submittedKey = QUIZ_FORM_SUBMITTED_PREFIX + resultParam;
      isSubmitted = Boolean(localStorage.getItem(submittedKey));
      if (isSubmitted) {
        section.classList.add('hidden');
        setSuccessState(true);
      } else {
        section.classList.remove('hidden');
        setSuccessState(false);
      }
    }

    // Sticky trigger interactions:
    // - Clicking the svg-wrapper should hide the sticky trigger.
    // - Clicking the text-button-wrapper should show the sticky trigger (remove hidden) only.
    // - Clicking the rest of the button triggers the original "open form" behavior.
    if (triggerSvgWrapper && triggerWrapper) {
      triggerSvgWrapper.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        triggerWrapper.classList.add('hidden');
      });
    }

    if (triggerButton && triggerWrapper) {
      triggerButton.addEventListener('click', function (e) {
        const clickedTextWrapper = e && e.target && e.target.closest
          ? e.target.closest('.text-button-wrapper')
          : null;

        if (clickedTextWrapper) {
          triggerWrapper.classList.remove('hidden');
        }

        if (!resultParam) return;
        section.classList.remove('hidden');
        setSuccessState(isSubmitted);
      });
    }

    // Close button can be inside or outside the form depending on section markup.
    // Use a delegated handler so it works even if the markup changes.
    section.addEventListener('click', function (e) {
      const closeBtn = e.target && e.target.closest
        ? e.target.closest('.quiz-form-close-btn, .custom-klaviyo-form-close-btn')
        : null;
      if (!closeBtn) return;
      e.preventDefault();
      section.classList.add('hidden');
    });

    const form = section.querySelector('#quiz-contact-form');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const nameInput = form.querySelector('#quiz-name') || document.getElementById('quiz-name');
      const emailInput = form.querySelector('#quiz-email') || document.getElementById('quiz-email');
      const errorMessage = form.querySelector('#quiz-form-error') || document.getElementById('quiz-form-error');
      const submitBtn = form.querySelector('.quiz-form-submit-btn');

      if (errorMessage) {
        errorMessage.style.display = 'none';
        errorMessage.textContent = '';
      }

      const name = nameInput ? nameInput.value.trim() : '';
      const email = emailInput ? emailInput.value.trim() : '';

      if (!name) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter your name.';
          errorMessage.style.display = 'block';
        }
        if (nameInput) nameInput.focus();
        return;
      }
      if (!email) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter your email address.';
          errorMessage.style.display = 'block';
        }
        if (emailInput) emailInput.focus();
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        if (errorMessage) {
          errorMessage.textContent = 'Please enter a valid email address.';
          errorMessage.style.display = 'block';
        }
        if (emailInput) emailInput.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      const currentResultParam = getUrlParameter(window.location.href, 'result');
      if (!currentResultParam) {
        if (errorMessage) {
          errorMessage.textContent = 'Session expired. Please restart the quiz.';
          errorMessage.style.display = 'block';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'See My Results';
        }
        return;
      }

      try {
        const apiUrl = 'https://quiz.miiroko.com/api/v1/quiz/start';
        const formData = new FormData();
        formData.append('session_token', currentResultParam);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('shop', SHOP_DOMAIN);

        const response = await fetch(apiUrl, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' },
          mode: 'cors',
          credentials: 'omit'
        });

        if (!response.ok) {
          const errorText = await response.text().catch(() => 'Unknown error');
          throw new Error('Failed to submit form: ' + response.status);
        }

        const submittedKey = QUIZ_FORM_SUBMITTED_PREFIX + currentResultParam;
        localStorage.setItem(submittedKey, 'true');
        isSubmitted = true;
        setSuccessState(true);
        section.classList.add('hidden');
        window.location.reload();
      } catch (error) {
        console.error('Error submitting quiz contact form:', error);
        if (errorMessage) {
          errorMessage.textContent = 'An error occurred. Please try again.';
          errorMessage.style.display = 'block';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'See My Results';
        }
      }
    });
  }

  // Wait for DOM to be ready
  function init() {
    const run = function () {
      ensureResultPageParams();
      fetchQuizResult();
      initKlaviyoFormSection();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      setTimeout(run, 50);
    }
  }

  init();
})();
